import type { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

import * as styles from './login.css';

export function GoldllenLoginLayout({ children }: PropsWithChildren) {
  return (
    <div className={styles.page}>
      <main className={styles.formPanel}>
        <Link
          className={styles.eyebrow}
          to="/"
          aria-label="Goldllen — página inicial"
        >
          Goldllen / Acesso
        </Link>
        {children}
      </main>
      <aside className={styles.brandPanel} aria-label="Goldllen">
        <img
          className={styles.brandImage}
          src={`${environment.publicPath}imgs/goldllen-login-panel.png`}
          alt="Goldllen"
          width={950}
          height={1043}
        />
      </aside>
    </div>
  );
}
